import
{
	gsap,
	TweenMax,
	TimelineMax,
	Power0,
	Power1,
	Power2,
	Power3,
	Power4,
	Elastic,
}
from "gsap/all";
import
{
	ScrollTrigger
}
from "gsap/dist/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


$(function()
{
	$(".burger").on("click", function()
	{
		if (!$(this).hasClass("open"))
		{
			$(this).addClass("open");
			$("nav").css(
			{
				"visibility": "visible"
			});
		}
		else
		{
			$(this).removeClass("open");
			$("nav").css(
			{
				"visibility": "hidden"
			});
		}
	});

	var winWidth = $(window).width();

	//window resize
	function windowResize(e)
	{
		winWidth = $(window).width();

		if (winWidth < 576)
		{
			$(".burger").removeClass("open");
			$("nav").css(
			{
				"visibility": "hidden"
			});
		}
		if (winWidth >= 576)
		{
			$(".burger").removeClass("open");
			$("nav").css(
			{
				"visibility": "hidden"
			});
		}
		if (winWidth >= 768)
		{
			$(".burger").removeClass("open");
			$("nav").css(
			{
				"visibility": "visible"
			});
		}
		var i = 1;
	}
	$(window).on("resize", windowResize);
	$(window).on("load", function()
	{
		windowResize();
	});
	$("nav ul li a").on("click", function()
	{
		if (winWidth < 576)
		{
			if ($(".burger").hasClass("open"))
			{
				$(".burger").removeClass("open");
				$("nav").css(
				{
					"visibility": "hidden"
				});
			}
			else
			{
				$(".burger").addClass("open");
				$("nav").css(
				{
					"visibility": "visible"
				});
			}
		}
	});
	gsap.from($(".box--anime--diamond p img"), 1.5,
	{
		scrollTrigger:
		{
			trigger: ".box--anime--diamond", //アニメーションが始まるトリガーとなる要素
			start: 'top center', //アニメーションが始まる位置を指定
		},
		stagger:
		{
			from: "start",
			amount: 0.5
		},
		ease: Power4.easeOut,
		css:
		{
			opacity: 0,
			top: 50,
		}
	});
	gsap.from($(".ill-1"), 1.5,
	{
		scrollTrigger:
		{
			trigger: ".ill-1", //アニメーションが始まるトリガーとなる要素
			start: 'top center', //アニメーションが始まる位置を指定
		},
		stagger:
		{
			from: "start",
			amount: 0.5
		},
		ease: Power4.easeOut,
		css:
		{
			opacity: 0,
			top: 50,
		}
	});
	gsap.from($(".ill-2"), 1.5,
	{
		scrollTrigger:
		{
			trigger: ".ill-2", //アニメーションが始まるトリガーとなる要素
			start: 'top center', //アニメーションが始まる位置を指定
		},
		stagger:
		{
			from: "start",
			amount: 0.5
		},
		ease: Power4.easeOut,
		css:
		{
			opacity: 0,
			top: 50,
		}
	});
	gsap.from($(".ill-3"), 1.5,
	{
		scrollTrigger:
		{
			trigger: ".ill-3", //アニメーションが始まるトリガーとなる要素
			start: 'top center', //アニメーションが始まる位置を指定
		},
		stagger:
		{
			from: "start",
			amount: 0.5
		},
		ease: Power4.easeOut,
		css:
		{
			opacity: 0,
			top: 50,
		}
	});
});
